export default "__VITE_ASSET__BKWQx5s___"